/**
 * Adds locale prefix to relative URLs if needed.
 * Leaves external URLs (http/https) and URLs that already have a locale prefix unchanged.
 */
export function addLocalePrefix(url: string | null | undefined, locale: string): string {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("//")) {
    return url;
  }
  if (!url.startsWith("/")) {
    return url;
  }
  const segments = url.split("/").filter(Boolean);
  if (segments.length > 0) {
    const firstSegment = segments[0];
    if (firstSegment === locale) {
      return url;
    }
    if (firstSegment.includes("_") || firstSegment.includes("-") || firstSegment.length >= 2 && firstSegment.length <= 5 && /^[a-z]{2}/i.test(firstSegment)) {
      const restOfPath = `/${segments.slice(1).join("/")}`;
      return `/${locale}${restOfPath}`;
    }
  }
  return `/${locale}${url}`;
}